import { render } from "./AudienceComponent.vue?vue&type=template&id=49ed76e1"
import script from "./AudienceComponent.vue?vue&type=script&lang=js"
export * from "./AudienceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__